// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.params-container {
  justify-content: stretch;
  padding: 1rem;
  width: 100%;
  min-height: 35vh;
  min-width: 50vw;
}
.params-container .param {
  display: grid;
  grid-template-columns: 11rem max-content max-content 24px;
  grid-gap: 0.5rem;
  margin: auto 0 0.5rem 0;
  padding: 0.7rem;
  background-color: rgba(114, 191, 68, 0.0901960784);
  border-radius: 2px;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.2), 0 1px 0px 1px rgba(0, 0, 0, 0.04), 0 3px 0px -3px rgba(0, 0, 0, 0.12);
}
.params-container .param:focus-within {
  transform: scale(1.005);
}
.params-container .param.invalid {
  background-color: rgba(250, 177, 177, 0.27);
}
.params-container .param label {
  margin: auto 0;
  font-weight: bold;
}
.params-container .param input {
  z-index: 10;
  border: 1px solid #dfe0e1;
  border-radius: 5px;
  line-height: 1.5rem;
}
.params-container .param .param-value {
  margin: auto 0;
  text-align: center;
  font-family: "Source Sans Pro", Helvetica, sans-serif;
  font-size: 1rem;
}
.params-container .param .param-stored {
  color: grey;
  font-style: italic;
  margin: auto;
  max-height: 28px;
  text-align: right;
  margin-left: 2rem;
}
.params-container .param .param-validation {
  max-height: 200px;
  opacity: 1;
  margin: 0 auto;
  transition: max-height 0.5s ease-in-out, height 0.5s ease-in-out, opacity 0.5s ease-in-out, color 0.5s ease-in-out, margin 0.5s ease-in-out;
  color: lightcoral;
  font-style: italic;
  font-size: 0.8rem;
}
.params-container .param .param-validation.collapsed {
  color: lightgreen;
  max-height: 0;
  opacity: 0;
  margin: -30px auto 0 auto;
}

.readonly {
  color: #888 !important;
}

.param-handle {
  color: #888;
  opacity: 0.2;
  cursor: move;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.param-handle:hover {
  transform: scale(1.25);
  opacity: 0.5;
}

.dialog_close {
  height: 100%;
  display: flex;
  padding: 0;
  padding-right: 0.5rem;
}
.dialog_close .close_modal {
  height: 1.9rem;
  margin: auto;
}
.dialog_close .icon_close {
  color: white !important;
}

.left-space {
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/global-settings/global-settings.component.scss","webpack://./../../../Empyrean%20User%20Manager/Web/EmpyreanUserManager/src/app/components/global-settings/global-settings.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;ACCF;ADCE;EACE,aAAA;EACA,yDAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,kDAAA;EACA,kBAAA;EACA,mHAAA;ACCJ;ADCI;EACE,uBAAA;ACCN;ADEI;EACE,2CAAA;ACAN;ADGI;EACE,cAAA;EACA,iBAAA;ACDN;ADII;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;ACFN;ADKI;EACE,cAAA;EACA,kBAAA;EACA,qDAAA;EACA,eAAA;ACHN;ADMI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;ACJN;ADOI;EAEE,iBAAA;EACA,UAAA;EACA,cAAA;EACA,2IAAA;EAEA,iBAAA;EACA,kBAAA;EACA,iBAAA;ACPN;ADQM;EACE,iBAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;ACNR;;ADYA;EACE,sBAAA;ACTF;;ADYA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,4DAAA;ACTF;ADUE;EACE,sBAAA;EACA,YAAA;ACRJ;;ADYA;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,qBAAA;ACTF;ADUE;EACE,cAAA;EACA,YAAA;ACRJ;ADUE;EACE,uBAAA;ACRJ;;ADYA;EACE,gBAAA;ACTF","sourcesContent":[".params-container {\r\n  justify-content: stretch;\r\n  padding: 1rem;\r\n  width: 100%;\r\n  min-height: 35vh;\r\n  min-width: 50vw;\r\n\r\n  .param {\r\n    display: grid;\r\n    grid-template-columns: 11rem max-content max-content 24px;\r\n    grid-gap: 0.5rem;\r\n    margin: auto 0 0.5rem 0;\r\n    padding: 0.7rem;\r\n    background-color: #72bf4417;\r\n    border-radius: 2px;\r\n    box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.2), 0 1px 0px 1px rgba(0, 0, 0, 0.04), 0 3px 0px -3px rgba(0, 0, 0, 0.12);\r\n\r\n    &:focus-within {\r\n      transform: scale(1.005);\r\n    }\r\n\r\n    &.invalid {\r\n      background-color: rgba(250, 177, 177, 0.27);\r\n    }\r\n\r\n    label {\r\n      margin: auto 0;\r\n      font-weight: bold;\r\n    }\r\n\r\n    input {\r\n      z-index: 10;\r\n      border: 1px solid #dfe0e1;\r\n      border-radius: 5px;\r\n      line-height: 1.5rem;\r\n    }\r\n\r\n    .param-value {\r\n      margin: auto 0;\r\n      text-align: center;\r\n      font-family: 'Source Sans Pro', Helvetica, sans-serif;\r\n      font-size: 1rem;\r\n    }\r\n\r\n    .param-stored {\r\n      color: grey;\r\n      font-style: italic;\r\n      margin: auto;\r\n      max-height: 28px;\r\n      text-align: right;\r\n      margin-left: 2rem;\r\n    }\r\n\r\n    .param-validation {\r\n      // z-index: -1;\r\n      max-height: 200px;\r\n      opacity: 1;\r\n      margin: 0 auto;\r\n      transition: max-height 0.5s ease-in-out, height 0.5s ease-in-out, opacity 0.5s ease-in-out, color 0.5s ease-in-out,\r\n        margin 0.5s ease-in-out;\r\n      color: lightcoral;\r\n      font-style: italic;\r\n      font-size: 0.8rem;\r\n      &.collapsed {\r\n        color: lightgreen;\r\n        max-height: 0;\r\n        opacity: 0;\r\n        margin: -30px auto 0 auto;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.readonly {\r\n  color: #888 !important;\r\n}\r\n\r\n.param-handle {\r\n  color: #888;\r\n  opacity: 0.2;\r\n  cursor: move;\r\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n  &:hover {\r\n    transform: scale(1.25);\r\n    opacity: 0.5;\r\n  }\r\n}\r\n\r\n.dialog_close {\r\n  height: 100%;\r\n  display: flex;\r\n  padding: 0;\r\n  padding-right: 0.5rem;\r\n  .close_modal {\r\n    height: 1.9rem;\r\n    margin: auto;\r\n  }\r\n  .icon_close {\r\n    color: white !important;\r\n  }\r\n}\r\n\r\n.left-space {\r\n  margin-left: 5px;\r\n}\r\n",".params-container {\n  justify-content: stretch;\n  padding: 1rem;\n  width: 100%;\n  min-height: 35vh;\n  min-width: 50vw;\n}\n.params-container .param {\n  display: grid;\n  grid-template-columns: 11rem max-content max-content 24px;\n  grid-gap: 0.5rem;\n  margin: auto 0 0.5rem 0;\n  padding: 0.7rem;\n  background-color: rgba(114, 191, 68, 0.0901960784);\n  border-radius: 2px;\n  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.2), 0 1px 0px 1px rgba(0, 0, 0, 0.04), 0 3px 0px -3px rgba(0, 0, 0, 0.12);\n}\n.params-container .param:focus-within {\n  transform: scale(1.005);\n}\n.params-container .param.invalid {\n  background-color: rgba(250, 177, 177, 0.27);\n}\n.params-container .param label {\n  margin: auto 0;\n  font-weight: bold;\n}\n.params-container .param input {\n  z-index: 10;\n  border: 1px solid #dfe0e1;\n  border-radius: 5px;\n  line-height: 1.5rem;\n}\n.params-container .param .param-value {\n  margin: auto 0;\n  text-align: center;\n  font-family: \"Source Sans Pro\", Helvetica, sans-serif;\n  font-size: 1rem;\n}\n.params-container .param .param-stored {\n  color: grey;\n  font-style: italic;\n  margin: auto;\n  max-height: 28px;\n  text-align: right;\n  margin-left: 2rem;\n}\n.params-container .param .param-validation {\n  max-height: 200px;\n  opacity: 1;\n  margin: 0 auto;\n  transition: max-height 0.5s ease-in-out, height 0.5s ease-in-out, opacity 0.5s ease-in-out, color 0.5s ease-in-out, margin 0.5s ease-in-out;\n  color: lightcoral;\n  font-style: italic;\n  font-size: 0.8rem;\n}\n.params-container .param .param-validation.collapsed {\n  color: lightgreen;\n  max-height: 0;\n  opacity: 0;\n  margin: -30px auto 0 auto;\n}\n\n.readonly {\n  color: #888 !important;\n}\n\n.param-handle {\n  color: #888;\n  opacity: 0.2;\n  cursor: move;\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n.param-handle:hover {\n  transform: scale(1.25);\n  opacity: 0.5;\n}\n\n.dialog_close {\n  height: 100%;\n  display: flex;\n  padding: 0;\n  padding-right: 0.5rem;\n}\n.dialog_close .close_modal {\n  height: 1.9rem;\n  margin: auto;\n}\n.dialog_close .icon_close {\n  color: white !important;\n}\n\n.left-space {\n  margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
